import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

export const useDefinedParams = (expectedParams: string[]): string[] => {
  const nav = useNavigate();
  const params = useParams();
  const paramsKeys = Object.keys(params);
  if (paramsKeys.length != expectedParams.length) {
    nav('/404');
    return [];
  } else {
    const definedParams: string[] = [];
    paramsKeys.forEach(key => {
      if (expectedParams.indexOf(key) == -1) {
        nav('/404');
      } else {
        definedParams.push(params[key] as string);
      }
    });
    return definedParams;
  }
};
